import { z } from 'zod';

export const LayoutPartSchema = z.enum([
  'TITLE',
  'SUBTITLE1',
  'SUBTITLE2',
  'BODYTEXT1',
  'BODYTEXT2',
  'IMAGE1',
  'IMAGE2',
  'IMAGE3',
  'IMAGE4',
  'ANSWER_AREA',
  'CATEGORY_AREA',
  'FILL_IN_THE_BLANKS_AREA',
  'VIDEO',
  'DROP_ZONE_1',
  'DROP_ZONE_2',
  'DROP_ZONE_3',
  'DROP_ZONE_4',
  'TEXT_ITEM_1',
  'TEXT_ITEM_2',
  'TEXT_ITEM_3',
  'TEXT_ITEM_4',
]);
export type LayoutPart = z.infer<typeof LayoutPartSchema>;
